import { lazy, Suspense } from "react";

// The editor (TipTap) loads as its own chunk after hydration, like the app's other rich text
const EmailEditorImpl = lazy(() => import("./EmailEditor.impl"));

const EmailEditor = (props) => (
  <Suspense fallback={null}>
    <EmailEditorImpl {...props} />
  </Suspense>
);

export default EmailEditor;
